import { propOr } from 'ramda';
import { useUserContext } from '../withUser';
import { isUserAdmin } from '../pages/helpers/isUserAdmin';
import { hasRole } from '../components/users/utils/roles';
import { ROLES } from '../lib/rights';

const useOfferRole = (offerId) => {
  const { user, userTeam } = useUserContext();
  const userIsAdmin = isUserAdmin(user, userTeam);
  const userIsOfferEditor = hasRole(ROLES.offerEditor, propOr([], 'roles', userTeam), offerId);
  return { userIsAdmin, userIsOfferEditor };
};

export default useOfferRole;
